import { gql } from 'react-apollo';
import { revivalBasicInfo } from '../../../../graphql/fragments/church.js';

export const getRevivalInfo = gql`
  query getRevivalInfo($churchId: Int!, $periodStartTime: DateTime!, $periodEndTime: DateTime!) {
    statistics {
      churchManager: church_manager {
        revivalInfo: revival_info(church_id: $churchId, period_start_time: $periodStartTime,
                                  period_end_time: $periodEndTime) {
            ...revivalBasicInfo
        }
      }
    }
  }

    ${revivalBasicInfo}
`;

export const getChurchGroups = gql`
  query getChurchGroups($id: Int!) {
    church: church_by_id(id: $id) {
      id
      groups: church_groups {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`;

export const getRevivalWeeks = gql`
  query getRevivalWeeks($church_id: Int!) {
    church: church_by_id(id: $church_id) {
      id
      revival {
        id
        title
        image {
          default
        }
        preparationStartDate: preparation_start_date
        startDate: start_date
        endDate: end_date
        phase
        preparationDaysCount: preparation_days_count
        revivalDaysCount: revival_days_count
        weeks {
          phaseNumber: phase_number
          weekNumber: week_number
          startDate: start_date
          endDate: end_date
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/statistics/queries/queries.js